import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { getLinkLocationFrom } from '@shared/utils/experimentNavHelpers';
import {
  getIsArchivePage,
  getIsExperimentsPage
} from '@/selectors/routeSelectors';

export const useExperimentDiffPageNavigation = ({
  selectedExperimentKeys,
  projectName,
  workspace
}: {
  selectedExperimentKeys: string[];
  projectName: string;
  workspace: string;
}) => {
  const history = useHistory();

  const isExperimentsPage = useSelector(getIsExperimentsPage);
  const isArchive = useSelector(getIsArchivePage);

  const linkLocationFrom = getLinkLocationFrom({
    isArchive,
    isExperimentsPage
  });

  const getExperimentDiffPageUrl = () => {
    const experimentsQuery = selectedExperimentKeys.join(',');
    const archivePath = isArchive ? 'archive/' : '';

    return `/${workspace}/${projectName}/${archivePath}compare?experiments=${experimentsQuery}`;
  };

  const handleRouteToExperimentDiffPage = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    // Only use history.push when it's a regular click (not middle click, ctrl+click, etc.)
    if (!e.ctrlKey && !e.metaKey && e.button !== 1) {
      e.preventDefault();
      const url = getExperimentDiffPageUrl();
      history.push(url, {
        from: linkLocationFrom,
        prevLocation: history.location
      });
    }
  };

  return { getExperimentDiffPageUrl, handleRouteToExperimentDiffPage };
};
